/**
 * Creates an array of length n, filled with the numbers from 0 to n-1.
 * @see https://stackoverflow.com/a/65244361/16396979
 * @param length Length of the array
 */
export function createFilledArray(length: number) {
  const arr: number[] = Array(length);
  let i = 0;
  while (i < length) arr[i] = i++;
  return arr;
}

/**
 * Moves all items of a group into an ordered array.
 * Only orders the existing items, order can include ids that do
 * not exist in the items object.
 * @param order The keys of the array, in order.
 */
export function applyOrder<I>(
  items: { [id: string | number]: I },
  order: (string | number)[] | string[] | number[] | null
): I[] {
  if (order == null) return Object.values(items) as I[];

  const ordered: I[] = [];

  for (const i of order) {
    if (items[i] != null) ordered.push(items[i]);
  }

  return ordered;
}
